import { supabase } from "@/integrations/supabase/client";

const ATTR_KEY = "st_lead_attribution";
export const LEAD_DONE_KEY = "st_lead_captured";
export const LEAD_DISMISS_KEY = "st_lead_dismissed_at";

/** Normalises Nigerian numbers to +234XXXXXXXXXX. Returns null if invalid. */
export function normalizeNigerianPhone(input: string): string | null {
  let d = input.replace(/[^\d+]/g, "");
  if (d.startsWith("+")) d = d.slice(1);
  if (d.startsWith("234")) d = d.slice(3);
  if (d.startsWith("0")) d = d.slice(1);
  if (!/^[789][01]\d{8}$/.test(d)) return null;
  return `+234${d}`;
}

/** Remember where the visitor first came from (ad params), once per browser. */
export function captureAttribution() {
  try {
    if (localStorage.getItem(ATTR_KEY)) return;
    const p = new URLSearchParams(window.location.search);
    localStorage.setItem(
      ATTR_KEY,
      JSON.stringify({
        landing_path: window.location.pathname,
        referrer: document.referrer || null,
        utm_source: p.get("utm_source"),
        utm_medium: p.get("utm_medium"),
        utm_campaign: p.get("utm_campaign"),
        click_id: p.get("fbclid") || p.get("ttclid") || p.get("gclid"),
      }),
    );
  } catch { /* ignore */ }
}

export async function submitLead(fullName: string, phone: string, interest: string) {
  let attr: Record<string, string | null> = {};
  try { attr = JSON.parse(localStorage.getItem(ATTR_KEY) || "{}"); } catch { /* ignore */ }
  const { data: { user } } = await supabase.auth.getUser();
  const { error } = await supabase.from("leads" as any).insert({
    full_name: fullName.trim() || null,
    phone,
    interest,
    ...attr,
    landing_path: attr.landing_path || window.location.pathname,
    session_id: sessionStorage.getItem("st_session_id"),
    user_id: user?.id ?? null,
  } as any);
  // 23505 = phone already on the list — treat as success
  if (error && error.code !== "23505") throw error;
  localStorage.setItem(LEAD_DONE_KEY, "1");
}
